import Connection from './connection';
import Subscriptions from './subscriptions';

export default class Consumer
{
    readonly _url: string;
    subscriptions: Subscriptions;
    connection: Connection;

    /**
     * Constructor
     */
    constructor(url: string)
    {
        this._url          = url;
        this.subscriptions = new Subscriptions(this);
        this.connection    = new Connection(this);
    }

    get url()
    {
        return createWebSocketURL(this._url);
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    send(data: unknown): boolean
    {
        return this.connection.send(data);
    }

    connect(): boolean
    {
        return this.connection.open();
    }

    disconnect(): boolean|void
    {
        return this.connection.close({ allowReconnect: false });
    }

    ensureActiveConnection(): boolean|void
    {
        if (!this.connection.isActive())
        {
            return this.connection.open();
        }
    }
}

export function createWebSocketURL(url: any ): string
{
    if (typeof url === 'function')
    {
        url = url();
    }

    if (url && !/^wss?:/i.test(url))
    {
        const a    = document.createElement('a');
        a.href     = url;
        // Fix populating Location properties in IE. Otherwise, protocol will be blank.
        a.href     = a.href;
        a.protocol = a.protocol.replace('http', 'ws');
        return a.href;
    }
    else
    {
        return url;
    }
}
